import styled from 'styled-components';

import DropdownIndicator from '../../../shared/dropdown-styles';

const HalfWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > article {
    ${props => (props.theme.isXLarge ? `
      width: 48%;
      max-width: 326px;
    ` : `
      width: 100%;
    `)};
  }
`;

const SectionSeparator = styled.div`
  width: 100%;
  height: 0;
  border-top: 1px solid #D7DFE7;
`;

const PremiumSectionSeparator = styled(SectionSeparator)`
  border-top-color: #c19d3f;
`;

const Section = styled.section`
  display: flex;
  flex-direction: row;
  margin-top: 32px;
`;

const SectionSummary = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 222px;
  width: 222px;
`;

const SectionSummaryTitle = styled.div`
  font-size: 20px;
  font-weight: 800;
  line-height: 100%;
  text-transform: uppercase;
`;

const SectionSummaryDescription = styled.p`
  font-size: 16px;
  line-height: 130%;
  color: #627484;
`;

const SectionDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 24px;
`;

const SectionDetailLabel = styled.label`
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;

  textarea {
    resize: vertical;
  }
`;

const selectorStyles = {
  container: provided => ({
    ...provided,
    fontSize: 17,
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#19202d' : '#d7dfe7',
    '&:hover': {
      borderColor: '#19202d',
    },
    borderRadius: 3,
    outline: 'none',
    boxShadow: 'none',
    height: 40,
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: 40,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    // eslint-disable-next-line no-nested-ternary
    backgroundColor: state.isSelected ? '#19202d' : (state.isFocused ? '#f3f5fa' : '#fff'),
  }),
  placeholder: provided => ({
    ...provided,
    color: '#8ea3b5',
  }),
  valueContainer: provided => ({
    ...provided,
    marginTop: -11,
  }),
};

const selectorProps = {
  styles: selectorStyles,
  classNamesPrefix: 'sel',
  components: { DropdownIndicator },
};

export {
  HalfWrapper,
  PremiumSectionSeparator,
  Section,
  SectionDetailLabel,
  SectionDetails,
  SectionSeparator,
  SectionSummary,
  SectionSummaryDescription,
  SectionSummaryTitle,
  selectorStyles,
  selectorProps,
};
